const components: NodeListOf<Element> = document.querySelectorAll('.campaign-block');

export class CampaignBlock {
  constructor() {
    components.forEach((component) => {
      const backgroundImageContainer = component.querySelector('.campaign-image') as HTMLElement;
      const imageUrl = backgroundImageContainer?.dataset.backgroundImage;

      if (imageUrl) {
        let preloadImage: HTMLImageElement | null = document.createElement('img');
        if (preloadImage) {
          preloadImage.src = imageUrl;
          preloadImage.addEventListener('load', (event) => {
            component.classList.add('show');
            backgroundImageContainer.style.backgroundImage = `url(${imageUrl})`;
            preloadImage = null;
          });
        }
      } else {
        component?.classList.add('show');
      }
    });
  }
}
